export default "__VITE_ASSET__79hNfTxEZvtz$VFl5m3gcQ__"